import { logger } from "@/utils/logger";
import { createClient, SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database.types";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

let supabase: SupabaseClient<Database> | null = null;
export const isSupabaseEnabled = !!(supabaseUrl && supabaseAnonKey);

if (isSupabaseEnabled) {
  logger.info("🔗 Initializing Supabase client (database only - auth handled by AIEW)", {
    url: supabaseUrl,
    keyLength: supabaseAnonKey?.length,
    timestamp: new Date().toISOString(),
  });

  supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false, // Auth is handled by AIEW
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  });

  logger.info("✅ Supabase client initialized successfully (database access only)");
} else {
  logger.warn(
    "⚠️ Supabase environment variables not set. Database access disabled.",
    {
      hasUrl: !!supabaseUrl,
      hasKey: !!supabaseAnonKey,
      url: supabaseUrl ? `${supabaseUrl.substring(0, 30)}...` : "not set",
      keyLength: supabaseAnonKey?.length || 0,
    },
  );

  if (import.meta.env.DEV) {
    console.warn(
      "Supabase environment variables not set. Database access disabled.",
    );
  }
}

export { supabase };

// NOTE: All authentication is now handled by AIEW (AI Edge Website)
// The Supabase client is retained only for potential database access if needed
// All auth-related functions (signUp, signIn, signOut, etc.) have been removed
// as authentication is managed through AIEW's centralized auth system
